module.exports = __webpack_public_path__ + "static/media/logicplan.2fe3e740.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/logicplan.webp
// module id = 729
// module chunks = 0